import { render, staticRenderFns } from "./ShownSessionDialog.vue?vue&type=template&id=f489f3c0&scoped=true&"
import script from "./ShownSessionDialog.vue?vue&type=script&lang=js&"
export * from "./ShownSessionDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShownSessionDialog.css?vue&type=style&index=0&id=f489f3c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f489f3c0",
  null
  
)

export default component.exports